var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileAvi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 151,
    viewBox: "0 0 122 151",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Canvas",
    transform: "translate(4338 1608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path0_fill",
    transform: "translate(-4337.06 -1607.36)",
    fill: "#D9DEE0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path1_fill",
    transform: "translate(-4312.02 -1502.97)",
    fill: "#C3272F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -4307.84 -1531.41)",
    fill: "#201F1F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -4296.88 -1511.32)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "file-avi_svg__file-avi_svg__mask0_outline_ins"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path3_fill",
    fill: "white",
    transform: "matrix(1 0 0 -1 -4296.88 -1511.32)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#file-avi_svg__file-avi_svg__mask0_outline_ins)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path4_stroke_2x",
    transform: "matrix(1 0 0 -1 -4296.88 -1511.32)",
    fill: "#201F1F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -4290.19 -1517.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -4290.19 -1525.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -4290.19 -1532.96)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -4290.19 -1540.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path8_fill",
    transform: "matrix(1 0 0 -1 -4260.36 -1517.75)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path9_fill",
    transform: "matrix(1 0 0 -1 -4260.36 -1525.39)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path9_fill",
    transform: "matrix(1 0 0 -1 -4260.36 -1532.96)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path10_fill",
    transform: "matrix(1 0 0 -1 -4260.36 -1540.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -4290.19 -1547.91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path10_fill",
    transform: "matrix(1 0 0 -1 -4260.36 -1547.91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "file-avi_svg__file-avi_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi_svg__file-avi_svg__path11_fill",
    transform: "matrix(1 0 0 -1 -4279.35 -1527)",
    fill: "#C3272F"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path0_fill",
    d: "M 86.4752 0L 8.6458 0C 3.876 0 -1.31138e-08 3.75657 -1.31138e-08 8.40343L -1.31138e-08 141.926C -1.31138e-08 146.568 3.876 150.33 8.6458 150.33L 112.418 150.33C 117.198 150.33 121.064 146.568 121.064 141.926L 121.064 33.6137L 86.4752 0ZM 86.4752 11.8811L 108.839 33.6137L 86.4752 33.6137L 86.4752 11.8811ZM 112.419 141.926L 8.6458 141.926L 8.6458 8.40343L 77.8276 8.40343L 77.8276 33.6137C 77.8276 38.2556 81.695 42.0171 86.4734 42.0171L 112.418 42.0171L 112.418 141.926L 112.419 141.926Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path1_fill",
    d: "M 31.7758 20.1713C 31.8593 20.3884 31.901 20.5721 31.901 20.7224C 31.901 21.0731 31.7758 21.3737 31.5252 21.6242C 31.2747 21.8747 30.9658 22 30.5983 22C 30.3478 22 30.1057 21.9332 29.8719 21.7996C 29.6547 21.6493 29.4961 21.4489 29.3959 21.1984L 27.993 17.6912L 18.9996 17.6912L 17.5717 21.1984C 17.4548 21.4489 17.2878 21.6493 17.0707 21.7996C 16.8535 21.9332 16.6197 22 16.3692 22C 16.0018 22 15.6928 21.8747 15.4423 21.6242C 15.2085 21.357 15.0916 21.0481 15.0916 20.6973C 15.0916 20.5303 15.1334 20.3383 15.2169 20.1212L 22.2563 3.31174C 22.5068 2.72721 22.916 2.43495 23.4838 2.43495C 24.085 2.43495 24.4942 2.72721 24.7113 3.31174L 31.7758 20.1713ZM 19.8764 15.5368L 27.1162 15.5368L 23.5339 6.61851L 19.8764 15.5368ZM 47.0332 2.43495C 47.4006 2.43495 47.6845 2.53515 47.8849 2.73556C 48.102 2.93598 48.2106 3.19484 48.2106 3.51215C 48.2106 3.71256 48.1605 3.92968 48.0603 4.16349L 40.6451 21.1733C 40.428 21.7244 40.0355 22 39.4677 22C 38.9332 22 38.5408 21.7244 38.2903 21.1733L 30.9502 4.38895C 30.8166 4.03823 30.7498 3.74597 30.7498 3.51215C 30.7498 3.17814 30.85 2.91927 31.0504 2.73556C 31.2676 2.53515 31.5598 2.43495 31.9272 2.43495C 32.5118 2.43495 32.9126 2.69381 33.1297 3.21154L 39.4426 18.3425L 45.8557 3.21154C 45.9727 2.91092 46.123 2.71051 46.3067 2.61031C 46.4904 2.4934 46.7325 2.43495 47.0332 2.43495ZM 52.527 22C 52.1596 22 51.8506 21.8747 51.6001 21.6242C 51.3496 21.3737 51.2244 21.0648 51.2244 20.6973L 51.2244 3.73762C 51.2244 3.3535 51.3496 3.04453 51.6001 2.81072C 51.8506 2.56021 52.1596 2.43495 52.527 2.43495C 52.9111 2.43495 53.2201 2.56021 53.4539 2.81072C 53.7044 3.04453 53.8297 3.3535 53.8297 3.73762L 53.8297 20.6973C 53.8297 21.0648 53.7044 21.3737 53.4539 21.6242C 53.2201 21.8747 52.9111 22 52.527 22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path2_fill",
    d: "M 4.85489 1.86879L 14.0589 0L 43.1724 22.8426L 43.8904 24.7895C 44.3474 26.3681 44.0863 28.0729 43.1724 29.4621C 42.3238 30.8512 40.8877 31.8615 39.2558 32.2403L 14.0589 38.1757C 13.602 38.302 13.0798 38.3652 12.5576 38.3652C 11.3826 38.3652 10.2729 38.0495 9.22844 37.4812C 7.79235 36.6603 6.74792 35.2712 6.35626 33.6926L 0.220234 9.31961C -0.236704 7.74105 0.0244031 6.0362 0.938279 4.64706C 1.78688 3.25793 3.22297 2.24765 4.85489 1.86879Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path3_fill",
    d: "M 7.19486 0L 40.2912 0C 44.2295 0 47.4861 3.18182 47.4861 7.19697L 47.4861 40.303C 47.4861 44.2424 44.3052 47.5 40.2912 47.5L 7.19486 47.5C 3.25662 47.5 0 44.3182 0 40.303L 0 7.19697C 0 3.25758 3.18089 0 7.19486 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path4_stroke_2x",
    d: "M 40.2912 -2.08761L 7.19486 -2.08761L 7.19486 2.08761L 40.2912 2.08761L 40.2912 -2.08761ZM 7.19486 -2.08761C 2.01307 -2.08761 -2.08761 2.11954 -2.08761 7.19697L 2.08761 7.19697C 2.08761 4.39561 4.3487 2.08761 7.19486 2.08761L 7.19486 -2.08761ZM -2.08761 7.19697L -2.08761 40.303L 2.08761 40.303L 2.08761 7.19697L -2.08761 7.19697ZM -2.08761 40.303C -2.08761 45.4849 2.11743 49.5876 7.19486 49.5876L 7.19486 45.4124C 4.39582 45.4124 2.08761 43.1515 2.08761 40.303L -2.08761 40.303ZM 7.19486 49.5876L 40.2912 49.5876L 40.2912 45.4124L 7.19486 45.4124L 7.19486 49.5876ZM 40.2912 49.5876C 45.473 49.5876 49.5737 45.3805 49.5737 40.303L 45.3985 40.303C 45.3985 43.1044 43.1374 45.4124 40.2912 45.4124L 40.2912 49.5876ZM 49.5737 40.303L 49.5737 7.19697L 45.3985 7.19697L 45.3985 40.303L 49.5737 40.303ZM 49.5737 7.19697C 49.5737 2.01515 45.3687 -2.08761 40.2912 -2.08761L 40.2912 2.08761C 43.0903 2.08761 45.3985 4.34849 45.3985 7.19697L 49.5737 7.19697Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path5_fill",
    d: "M 3.72078 0L 0 0L 0 3.59912L 3.72078 3.59912L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path6_fill",
    d: "M 3.72078 0L 0 0L 0 3.59912L 3.72078 3.59912L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path7_fill",
    d: "M 3.72078 0L 0 0L 0 3.59913L 3.72078 3.59913L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path8_fill",
    d: "M 3.72078 0L 1.99209e-06 0L 1.99209e-06 3.59912L 3.72078 3.59912L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path9_fill",
    d: "M 3.72078 0L 1.99209e-06 0L 1.99209e-06 3.59912L 3.72078 3.59912L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path10_fill",
    d: "M 3.72078 0L 1.99209e-06 0L 1.99209e-06 3.59913L 3.72078 3.59913L 3.72078 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi_svg__file-avi_svg__path11_fill",
    d: "M 0.718045 15.9435C 0.587491 15.9435 0.456937 15.9435 0.391661 15.8803C 0.130553 15.7541 4.98023e-07 15.5015 4.98023e-07 15.2489L 4.98023e-07 0.726139C 4.98023e-07 0.473569 0.130553 0.220998 0.391661 0.0947133C 0.652768 -0.0315718 0.913877 -0.0315718 1.10971 0.0947133L 13.3165 7.35611C 13.5123 7.48239 13.6429 7.73496 13.6429 7.98753C 13.6429 8.2401 13.5123 8.42953 13.3165 8.61896L 1.10971 15.8172C 0.979154 15.8803 0.848598 15.9435 0.718045 15.9435Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAvi);
export default __webpack_public_path__ + "static/media/file-avi.4529bdcb5885c491a612a0e204000bbb.svg";
export { ForwardRef as ReactComponent };